/**
 * @generated SignedSource<<580cdd6e730cd7b46a56d26850a7ce79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BodyFormatTypeEnum = "PARAGRAPH" | "PARAGRAPHANDMEDIA" | "%future added value";
export type CustomContentInput = {
  attribs?: CustomContentInputAttributes | null | undefined;
  row?: number | null | undefined;
  type: string;
};
export type CustomContentInputAttributes = {
  infiniteAdsAfterNumber?: string | null | undefined;
  percentage?: string | null | undefined;
  tag?: string | null | undefined;
};
export type articlePaginationQuery$variables = {
  bodyType?: BodyFormatTypeEnum | null | undefined;
  customContents?: ReadonlyArray<CustomContentInput | null | undefined> | null | undefined;
  entityId: string;
};
export type articlePaginationQuery$data = {
  readonly contents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"articleDividerArticle" | "articlePaginationCheckerContent" | "articlePaginationNavigationHistoryContent" | "articlePianoPaywallContent" | "articleRenderArticle" | "contextsContentReadMoreContextProviderContent" | "helpersCheckIsStyleArticle" | "helpersRosettaArticleContextArticle">;
      };
    }>;
  };
};
export type articlePaginationQuery = {
  response: articlePaginationQuery$data;
  variables: articlePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bodyType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v3 = [
  {
    "kind": "Literal",
    "name": "contentTypes",
    "value": [
      "ARTICLE",
      "VIDEO"
    ]
  },
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "entityIds.0",
            "variableName": "entityId"
          }
        ],
        "kind": "ListValue",
        "name": "entityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "customContents",
  "variableName": "customContents"
},
v6 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  (v5/*: any*/)
],
v7 = [
  (v4/*: any*/)
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isContent"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v20/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v22/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v29 = [
  (v4/*: any*/),
  (v22/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentSection",
  "storageKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v29/*: any*/),
      "storageKey": null
    },
    (v31/*: any*/)
  ],
  "type": "Section",
  "abstractKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v26/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v36/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v16/*: any*/),
            (v8/*: any*/),
            (v25/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v37/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v16/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/),
    (v35/*: any*/),
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v44/*: any*/),
      "type": "Author",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v44/*: any*/),
      "type": "Topic",
      "abstractKey": null
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v50 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "bodyType"
  }
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v52 = [
  (v51/*: any*/)
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v52/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": "size540x360",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "540x360"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"540x360\"})"
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v25/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsor",
  "kind": "LinkedField",
  "name": "sponsor",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v39/*: any*/),
    (v42/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v59/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v4/*: any*/),
        (v20/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v55/*: any*/),
    (v22/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v64 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v37/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    (v28/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/),
    (v35/*: any*/),
    (v65/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    (v49/*: any*/),
    (v39/*: any*/),
    (v57/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v16/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/),
    (v35/*: any*/),
    (v38/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v70 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v71 = {
  "alias": "size768x768",
  "args": (v70/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"768x768\"})"
},
v72 = {
  "alias": "size660w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "660w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"660w\"})"
},
v73 = {
  "alias": "size1320w",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1320w"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1320w\"})"
},
v74 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "landscape_250_99"
    }
  }
],
v75 = {
  "alias": "sizeLandscape250x99",
  "args": (v74/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
},
v76 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "wide_landscape"
    }
  }
],
v77 = {
  "alias": "size1280x720",
  "args": (v76/*: any*/),
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
},
v78 = {
  "alias": "size1200x800",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1200x800"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1200x800\"})"
},
v79 = {
  "alias": "size1020x680",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "1020x680"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": "style(filter:{\"style\":\"1020x680\"})"
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "youtubeId",
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    (v80/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "articlePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "articleDividerArticle"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "articlePaginationCheckerContent"
                  },
                  {
                    "args": (v6/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "articlePaginationNavigationHistoryContent"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "articlePianoPaywallContent"
                  },
                  {
                    "args": (v6/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "articleRenderArticle"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "contextsContentReadMoreContextProviderContent"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "helpersCheckIsStyleArticle",
                    "selections": (v11/*: any*/),
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "helpersRosettaArticleContextArticle",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "articlePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v4/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SectionSegmentV2",
                    "kind": "LinkedField",
                    "name": "sectionsV2",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isSectionUnion"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v23/*: any*/),
                              (v12/*: any*/),
                              (v24/*: any*/)
                            ],
                            "type": "Section",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v24/*: any*/)
                            ],
                            "type": "VideoSection",
                            "abstractKey": null
                          },
                          (v25/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v32/*: any*/),
                              (v35/*: any*/),
                              (v38/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Topic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sponsor",
                        "kind": "LinkedField",
                        "name": "sponsor",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v39/*: any*/),
                          (v42/*: any*/),
                          (v22/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "shortName",
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortUrl",
                    "storageKey": null
                  },
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bio",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SocialLink",
                        "kind": "LinkedField",
                        "name": "socialLinks",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "class",
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "AUTHOR_IMAGE"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "style": "300x300"
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"300x300\"})"
                          }
                        ],
                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "areaOfExpertise",
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "version",
                        "value": 2
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "advertZone",
                    "storageKey": "advertZone(version:2)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentLock",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "readingTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v50/*: any*/),
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": (v52/*: any*/),
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "subHeadline",
                    "plural": false,
                    "selections": (v52/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormattedValue",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      (v51/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleTypeSegment",
                        "kind": "LinkedField",
                        "name": "types",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleType",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v22/*: any*/),
                              (v12/*: any*/),
                              (v20/*: any*/),
                              (v26/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentCount",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "authorLocations",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authors",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "location",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortBio",
                            "storageKey": null
                          },
                          (v55/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentiment",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaywallType",
                        "kind": "LinkedField",
                        "name": "paywallTypes",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v22/*: any*/),
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleSpeech",
                        "kind": "LinkedField",
                        "name": "articleSpeeches",
                        "plural": true,
                        "selections": [
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "country",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "gender",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "voiceName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isSlideshow",
                            "storageKey": null
                          },
                          (v40/*: any*/),
                          (v49/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/)
                                ],
                                "type": "Section",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sponsor",
                            "kind": "LinkedField",
                            "name": "sponsor",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v43/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Correction",
                        "kind": "LinkedField",
                        "name": "corrections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "correction",
                            "plural": false,
                            "selections": (v52/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "moreOnThisArticles",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v22/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "237x147"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v41/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"237x147\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v49/*: any*/),
                                  (v39/*: any*/),
                                  (v57/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v53/*: any*/),
                              (v58/*: any*/),
                              (v60/*: any*/),
                              (v64/*: any*/),
                              (v66/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v32/*: any*/),
                              (v35/*: any*/),
                              (v65/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displaySlideShow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormattedValue",
                        "kind": "LinkedField",
                        "name": "multimediaEmbed",
                        "plural": false,
                        "selections": (v52/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "printHeadline",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "seriesContainer",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v22/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "series",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v27/*: any*/),
                                  (v46/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v49/*: any*/),
                                      (v39/*: any*/),
                                      {
                                        "alias": "size80x80",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "80x80"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v41/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"80x80\"})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v47/*: any*/),
                                  (v53/*: any*/),
                                  (v58/*: any*/),
                                  (v60/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Article",
                                        "kind": "LinkedField",
                                        "name": "seriesContainer",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "series",
                                            "plural": true,
                                            "selections": [
                                              (v16/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v7/*: any*/),
                                                "type": "Content",
                                                "abstractKey": "__isContent"
                                              },
                                              (v25/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v22/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v36/*: any*/),
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      (v54/*: any*/),
                                      (v63/*: any*/)
                                    ],
                                    "type": "Article",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v26/*: any*/),
                                      (v28/*: any*/),
                                      (v30/*: any*/),
                                      (v32/*: any*/),
                                      (v35/*: any*/),
                                      (v63/*: any*/)
                                    ],
                                    "type": "BaseWithApplicationAndUrlAlias",
                                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                  }
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              },
                              (v25/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/),
                              (v32/*: any*/),
                              (v35/*: any*/),
                              (v38/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Topic",
                        "kind": "LinkedField",
                        "name": "firstTopic",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v12/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 4
                              },
                              {
                                "kind": "Literal",
                                "name": "orderBy",
                                "value": {
                                  "direction": "DESC",
                                  "field": "PUBLISHED_DATE"
                                }
                              }
                            ],
                            "concreteType": "ContentConnection",
                            "kind": "LinkedField",
                            "name": "contents",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v4/*: any*/),
                                      (v17/*: any*/),
                                      (v27/*: any*/),
                                      (v46/*: any*/),
                                      (v67/*: any*/),
                                      (v47/*: any*/),
                                      (v53/*: any*/),
                                      (v58/*: any*/),
                                      (v60/*: any*/),
                                      (v22/*: any*/),
                                      (v64/*: any*/),
                                      (v66/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "contents(first:4,orderBy:{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"})"
                          },
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sponsor",
                            "kind": "LinkedField",
                            "name": "sponsor",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v39/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v68/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Glossary",
                        "kind": "LinkedField",
                        "name": "glossary",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "term",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "translation",
                            "storageKey": null
                          },
                          (v56/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasVideoContent",
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": "coverHero",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "HERO"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"HERO\"})"
                      },
                      (v26/*: any*/),
                      {
                        "alias": "coverDesktop",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "COVER"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"COVER\"})"
                      },
                      {
                        "alias": "coverMobile",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "COVER_MOBILE"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "relatedLinks",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sponsor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PdfFile",
                        "kind": "LinkedField",
                        "name": "pdfFiles",
                        "plural": true,
                        "selections": [
                          (v40/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "seriesReverseOrder",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "series",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v27/*: any*/),
                              (v60/*: any*/),
                              (v46/*: any*/),
                              (v67/*: any*/),
                              (v47/*: any*/),
                              (v53/*: any*/),
                              (v58/*: any*/),
                              (v48/*: any*/),
                              (v21/*: any*/),
                              (v66/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v36/*: any*/),
                                  (v54/*: any*/),
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v63/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v69/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Video",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "styleMoreOnThisArticles",
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "moreOnThisArticles",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v22/*: any*/),
                          (v68/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v22/*: any*/),
                                  (v59/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v46/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  (v40/*: any*/),
                                  (v49/*: any*/),
                                  (v39/*: any*/),
                                  (v71/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v47/*: any*/),
                              (v16/*: any*/),
                              (v53/*: any*/),
                              (v58/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v54/*: any*/),
                                  (v63/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v39/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v75/*: any*/),
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/),
                              (v71/*: any*/),
                              {
                                "alias": "landscape250x99",
                                "args": (v74/*: any*/),
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v41/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
                              },
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "leadingSlides",
                                "plural": true,
                                "selections": [
                                  (v49/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v72/*: any*/),
                                  (v73/*: any*/),
                                  (v75/*: any*/),
                                  (v77/*: any*/),
                                  (v78/*: any*/),
                                  (v79/*: any*/),
                                  (v71/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v81/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v81/*: any*/),
                          (v82/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      (v82/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/),
                      (v28/*: any*/),
                      (v30/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v30/*: any*/),
                                              (v32/*: any*/),
                                              (v35/*: any*/),
                                              (v38/*: any*/)
                                            ],
                                            "type": "BaseWithApplicationAndUrlAlias",
                                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                          }
                                        ],
                                        "type": "Section",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "disableOffPlatformContent",
                                "storageKey": null
                              },
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": "generic_og",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "style": "og_image_scmp_generic"
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "styles": [
                                            "og_postmag",
                                            "og_image_style",
                                            "og_image_scmp_analysis",
                                            "og_image_scmp_explainer",
                                            "og_image_scmp_editorial",
                                            "og_image_scmp_fact_check",
                                            "og_image_scmp_live",
                                            "og_image_scmp_obituary",
                                            "og_image_scmp_opinion",
                                            "og_image_scmp_review",
                                            "og_image_scmp_series",
                                            "og_image_scmp_generic"
                                          ]
                                        }
                                      }
                                    ],
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "styles",
                                    "plural": true,
                                    "selections": [
                                      (v40/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "style",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                                  },
                                  (v39/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v70/*: any*/),
                                    "concreteType": "ImageStyle",
                                    "kind": "LinkedField",
                                    "name": "style",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": "style(filter:{\"style\":\"768x768\"})"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "subHeadline",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v50/*: any*/),
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "body",
                                "plural": false,
                                "selections": (v19/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "keywords",
                                "storageKey": null
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v81/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v31/*: any*/)
                        ],
                        "type": "Section",
                        "abstractKey": null
                      }
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v80/*: any*/),
                      (v69/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "orientation",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "MAIN_IMAGE"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "landscape",
                            "args": (v76/*: any*/),
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                          },
                          {
                            "alias": "portrait",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "style": "portrait"
                                }
                              }
                            ],
                            "concreteType": "ImageStyle",
                            "kind": "LinkedField",
                            "name": "style",
                            "plural": false,
                            "selections": (v41/*: any*/),
                            "storageKey": "style(filter:{\"style\":\"portrait\"})"
                          }
                        ],
                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoSource",
                        "kind": "LinkedField",
                        "name": "videoSource",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35a795ebb7a628a44803b28d07a47c92",
    "id": null,
    "metadata": {},
    "name": "articlePaginationQuery",
    "operationKind": "query",
    "text": "query articlePaginationQuery(\n  $entityId: String!\n  $customContents: [CustomContentInput]\n  $bodyType: BodyFormatTypeEnum\n) {\n  contents(filter: {entityIds: [$entityId]}, contentTypes: [ARTICLE, VIDEO], first: 1) {\n    edges {\n      node {\n        __typename\n        entityId\n        ...articleDividerArticle\n        ...articlePaginationCheckerContent\n        ...articlePaginationNavigationHistoryContent_3o8td4\n        ...articlePianoPaywallContent\n        ...articleRenderArticle_3o8td4\n        ...contextsContentReadMoreContextProviderContent\n        ...helpersCheckIsStyleArticle\n        ...helpersRosettaArticleContextArticle\n        id\n      }\n    }\n  }\n}\n\nfragment actionWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    ...articleCommentsTriggerArticle\n    ...articlePrintArticle\n  }\n  ...copyLinkArticle20CopyLinkContent\n  ...entityLink\n}\n\nfragment appButtonContent on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment article20DateContent on Content {\n  __isContent: __typename\n  ...hooksArticleDateUtilsContent\n}\n\nfragment articleAdditionalInfoBoxArticleContent on Content {\n  __isContent: __typename\n  ...contentSchemaRenderContent\n}\n\nfragment articleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    ...entityFollowButtonBase\n    ...authorAvatarAuthor\n    id\n  }\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...helpersCheckIsPlusArticle\n  ...plusArticleAuthorBlockArticle\n  ...authorAvatarsArticle\n}\n\nfragment articleAuthorDetailsContent on Content {\n  __isContent: __typename\n  authors {\n    bio\n    entityId\n    ...authorCardAuthor\n    id\n  }\n}\n\nfragment articleBaseAdvertisingInfoArticle on Content {\n  __isContent: __typename\n  __typename\n  advertZone(version: 2)\n  entityId\n  contentLock\n  topics {\n    entityId\n    sponsor {\n      __typename\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n    paywallTypes {\n      entityId\n      id\n    }\n    ...helpersIsArchiveWallArticle\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment articleBeforeYouGoWidget on Content {\n  __isContent: __typename\n  ...beforeYouGoActionWidgetContent\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleCorrectionsWidgetArticle on Article {\n  corrections {\n    correction {\n      json\n    }\n    timestamp\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment articleDateContent on Content {\n  __isContent: __typename\n  ...defaultArticleDateContent\n  ...article20DateContent\n}\n\nfragment articleDividerArticle on Content {\n  __isContent: __typename\n  ...helpersCheckIsStyleArticle\n}\n\nfragment articleFurtherReadingWidgetArticle on Article {\n  sponsorType\n  moreOnThisArticles {\n    ...articleWidgetContent\n    entityId\n    id\n  }\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articleImageGalleryContent on Content {\n  __isContent: __typename\n  ...helpersCheckIsStyleArticle\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment articleLeadingArticle on Article {\n  entityId\n  sponsorType\n  displaySlideShow\n  ...articleLeadingImagesContent\n  ...contentCoverVideoContent\n  ...contentSchemaRenderContent\n  ...helpersIsArticleVideoAsHeroArticle\n}\n\nfragment articleLeadingImagesContent on Content {\n  __isContent: __typename\n  headline\n  images {\n    title\n    type\n    url\n    isSlideshow\n    size660w: style(filter: {style: \"660w\"}) {\n      url\n    }\n    size1320w: style(filter: {style: \"1320w\"}) {\n      url\n    }\n    sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size1280x720: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size1020x680: style(filter: {style: \"1020x680\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  ... on Article {\n    leadingSlides {\n      title\n      type\n      url\n      size660w: style(filter: {style: \"660w\"}) {\n        url\n      }\n      size1320w: style(filter: {style: \"1320w\"}) {\n        url\n      }\n      sizeLandscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n        url\n      }\n      size1280x720: style(filter: {style: \"wide_landscape\"}) {\n        url\n      }\n      size1200x800: style(filter: {style: \"1200x800\"}) {\n        url\n      }\n      size1020x680: style(filter: {style: \"1020x680\"}) {\n        url\n      }\n      size768x768: style(filter: {style: \"768x768\"}) {\n        url\n      }\n    }\n  }\n}\n\nfragment articleMoreOnThisListArticle on Article {\n  moreOnThisArticles {\n    ...entityLink\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    images {\n      url\n      style(filter: {style: \"237x147\"}) {\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment articleMoreOnThisListStyleArticle on Article {\n  styleMoreOnThisArticles: moreOnThisArticles {\n    ...entityLink\n    ...magazinesStyleArticleMoreOnThisContentItemContent\n    entityId\n    id\n  }\n}\n\nfragment articlePaginationCheckerContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment articlePaginationNavigationHistoryContent_3o8td4 on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...hooksTrackCurrentItemBase_3o8td4\n}\n\nfragment articlePianoPaywallContent on Content {\n  __isContent: __typename\n  ...hooksPaywallPromiseContent\n}\n\nfragment articlePrintArticle on Article {\n  ...contentShareWidgetContent\n}\n\nfragment articlePrintHeadlineMessageArticle on Article {\n  printHeadline\n}\n\nfragment articleReadingTimeContent on Content {\n  __isContent: __typename\n  readingTime\n}\n\nfragment articleRelatedTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    id\n  }\n}\n\nfragment articleRenderArticle_3o8td4 on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    sponsorType\n  }\n  ...actionWidgetContent\n  ...articleAdditionalInfoBoxArticleContent\n  ...articleAuthorBlockArticle\n  ...articleAuthorDetailsContent\n  ...articleBaseAdvertisingInfoArticle\n  ...articleBeforeYouGoWidget\n  ...articleCommentsTriggerArticle\n  ...articleCorrectionsWidgetArticle\n  ...articleDateContent\n  ...articleFurtherReadingWidgetArticle\n  ...articleImageGalleryContent\n  ...articleLeadingArticle\n  ...articleMoreOnThisListArticle\n  ...articlePianoPaywallContent\n  ...articlePrintHeadlineMessageArticle\n  ...articleReadingTimeContent\n  ...articleRelatedTopicsContent\n  ...articleSectionsContent\n  ...articleSeriesArticle\n  ...articleShareWidgetArticle\n  ...articleSpeechInlineWidgetArticle\n  ...articleSpeechPlayerPortalArticle\n  ...articleSponsorContent\n  ...articleTopicContent\n  ...articleTopicFollowWidgetArticle\n  ...articleTopicsContent\n  ...articleTopicWidgetArticle\n  ...articleVocabBoxArticle\n  ...authorAvatarsArticle\n  ...authorNamesArticle\n  ...authorShortBioArticle\n  ...contentActionBarContent\n  ...contentBodyContent_3o8td4\n  ...contentHeadlineContent\n  ...contentHeadlineTagContent\n  ...contentLiveTagContent\n  ...contentReadMoreButtonContent\n  ...contentSchemaRenderContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...genericArticleContent\n  ...globalCheckerContent\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckArticleRenderTypeArticle\n  ...helpersCheckIsVideoContent\n  ...helpersGetArticleTypeArticle\n  ...helpersIsPlusInlinePaywall\n  ...infographicArticleArticle\n  ...liveArticleArticle\n  ...morningStudioArticleContent\n  ...newsletterArticleArticle\n  ...pianoIntegrationArticle\n  ...plusColumnsArticleContent\n  ...plusGenericArticleContent\n  ...postMagazineArticleContent\n  ...seriesArticleArticle\n  ...styleArticleContent\n  ...videoArticleContent\n}\n\nfragment articleSectionsContent on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n      }\n      ... on VideoSection {\n        name\n        published\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment articleSeoArticle_3o8td4 on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents, type: $bodyType) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleSeriesArticle on Article {\n  seriesContainer {\n    entityId\n    id\n  }\n  ...inlineArticleSeriesInlineArticle\n  ...carouselArticleSeriesCarouselArticle\n}\n\nfragment articleSeriesCarouselContent on Content {\n  __isContent: __typename\n  entityId\n  ... on Article {\n    seriesContainer {\n      series {\n        __typename\n        ... on Content {\n          __isContent: __typename\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      id\n    }\n  }\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...hooksContentItemProvidersContent_3n3tyT\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  articleSpeeches {\n    url\n  }\n  ...genericArticleSpeechInlineWidgetGenericArticle\n}\n\nfragment articleSpeechPlayerPortalArticle on Article {\n  entityId\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSponsorContent on Article {\n  topics {\n    entityId\n    sponsor {\n      description {\n        json\n      }\n      ...sponsorTagSponsor\n      id\n    }\n    id\n  }\n  ...helpersUseContentSponsorContent\n  ...helpersCheckIsMainTopicContent\n  ...contentSchemaRenderContent\n}\n\nfragment articleTitleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n  authors {\n    name\n    id\n  }\n}\n\nfragment articleTopicContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment articleTopicFollowWidgetArticle on Article {\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    disableFollow\n    entityId\n    name\n    entityUuid\n    id\n  }\n}\n\nfragment articleTopicWidgetArticle on Article {\n  entityId\n  sponsorType\n  firstTopic {\n    ...entityLink\n    ...followButtonBase\n    entityId\n    name\n    disableFollow\n    contents(first: 4, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n      edges {\n        node {\n          __typename\n          entityId\n          ...articleWidgetContent\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment articleTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    entityUuid\n    name\n    id\n  }\n}\n\nfragment articleVocabBoxArticle on Article {\n  glossary {\n    term\n    translation\n    description {\n      json\n    }\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment articleWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ... on Article {\n    sponsorType\n  }\n  ...entityLink\n  ...hooksContentItemProvidersContent_2aLOLQ\n}\n\nfragment atomsCurrentArticleAtomBase_3o8td4 on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3o8td4\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...helpersRosettaArticleContextArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  entityUuid\n  name\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n}\n\nfragment authorAvatarsArticle on Article {\n  authors {\n    entityId\n    ...entityLink\n    ...authorAvatarAuthor\n    ...entityFollowButtonBase\n    id\n  }\n}\n\nfragment authorBioAuthor on Author {\n  bio\n}\n\nfragment authorCardAuthor on Author {\n  ...styleAuthorCardAuthor\n  ...defaultAuthorCardAuthor\n  ...plusAuthorCardAuthor\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n  entityUuid\n}\n\nfragment authorNamesArticle on Article {\n  authorLocations\n  authors {\n    entityId\n    location\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment authorRoleAuthor on Author {\n  role {\n    text\n  }\n}\n\nfragment authorShortBioArticle on Article {\n  authors {\n    shortBio\n    id\n  }\n}\n\nfragment authorSocialLinksAuthor on Author {\n  socialLinks {\n    class\n    title\n    url\n  }\n}\n\nfragment beforeYouGoActionWidgetContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n  ...articlePrintArticle\n  ...articleShareWidgetArticle\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment blockquoteQuotePlusGenericArticleContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment breadcrumbNewsletterArticleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    country\n    gender\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment carouselArticleSeriesCarouselArticle on Article {\n  entityId\n  seriesContainer {\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    series {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n        urlAlias\n        ...articleSeriesCarouselContent\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...entityLink\n    id\n  }\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentBodyContent_3o8td4 on Content {\n  __isContent: __typename\n  entityId\n  body(customContents: $customContents, type: $bodyType) {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentCoverImageContent_2Ihffa on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_3MAHTt on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_48pEL6 on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size80x80: style(filter: {style: \"80x80\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_7c6gD on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverVideoContent on Content {\n  __isContent: __typename\n  ... on Article {\n    multimediaEmbed {\n      json\n    }\n    ...contentSchemaRenderContent\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveArticleArticle on Article {\n  ...itemLiveArticleContentArticle\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterArticleArticle on Article {\n  entityId\n  relatedLinks\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        relatedNewsletters {\n          ...helpersMassageToNewsletterItemNewsletter\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentPublishedDateContent on Content {\n  __isContent: __typename\n  publishedDate\n}\n\nfragment contentReadMoreButtonContent on Content {\n  __isContent: __typename\n  ...appButtonContent\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n  ... on Video {\n    youtubeId\n  }\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentUpdatedDateContent on Content {\n  __isContent: __typename\n  updatedDate\n}\n\nfragment contextsContentReadMoreContextProviderContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksReadMoreTypeformContent\n  ... on Article {\n    sponsorType\n  }\n}\n\nfragment copyLinkArticle20CopyLinkContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment defaultArticleDateContent on Content {\n  __isContent: __typename\n  ...hooksArticleDateUtilsContent\n}\n\nfragment defaultAuthorCardAuthor on Author {\n  ...authorAvatarAuthor\n  ...authorBioAuthor\n  ...authorNameAuthor\n  ...authorRoleAuthor\n  ...entityFollowButtonBase\n  ...followButtonBase\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment genericArticleContent on Content {\n  __isContent: __typename\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...articleBaseAdvertisingInfoArticle\n  ...globalCheckerContent\n  ...helpersCheckAnnouncementArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersIsLiteWallArticle\n  ...hooksContentHelperContent\n  ...shareArticle20Content\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  articleSpeeches {\n    url\n  }\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n}\n\nfragment globalCheckerContent on Content {\n  __isContent: __typename\n  ...articlePianoPaywallContent\n}\n\nfragment headerMorningStudioArticle on Article {\n  ...articleSponsorContent\n  ...subheaderMorningStudioSubheaderContent\n  headline\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment headerNewsletterArticleArticle on Article {\n  headline\n  ...issuesNewsletterArticleArticle\n  ...breadcrumbNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckAnnouncementArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckArticleIsInSectionsArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckArticleRenderTypeArticle on Content {\n  __isContent: __typename\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersCheckIsVideoContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment helpersCheckCanShowInPlusPlatformContent on Content {\n  __isContent: __typename\n  __typename\n  ...helpersCheckArticleIsInSectionsArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersGetArticleTypeArticle\n  ...helpersUseContentSponsorContent\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsVideoContent on Content {\n  __isContent: __typename\n  __typename\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersGetPdfFileUrlArticle on Article {\n  pdfFiles {\n    url\n  }\n}\n\nfragment helpersGetVideoYoutubeIdVideo on Video {\n  youtubeId\n  videoSource {\n    id\n    type\n  }\n}\n\nfragment helpersIsArchiveWallArticle on Article {\n  createdDate\n  publishedDate\n  paywallTypes {\n    entityId\n    id\n  }\n  ...helpersIsVelocityWallArticle\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersIsLiteWallArticle on Article {\n  createdDate\n  publishedDate\n}\n\nfragment helpersIsPlusInlinePaywall on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersIsSignInWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersIsVelocityWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersRosettaArticleContextArticle on Content {\n  __isContent: __typename\n  topics {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersSendPdfFileTrackingArticle on Article {\n  entityId\n  pdfFiles {\n    name\n  }\n  ...helpersGetArticleTypeArticle\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksArticleDateUtilsContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksContentItemProvidersContent_2aLOLQ on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2niEwz on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_2Ihffa\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ...contentUpdatedDateContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3JkJ9S on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_7c6gD\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3n3tyT on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_48pEL6\n  ...contentHeadlineContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3wWJWe on Content {\n  __isContent: __typename\n  ...contentCoverImageContent_3MAHTt\n  ...contentHeadlineContent\n  ...contentPublishedDateContent\n  ...contentSummaryContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksReadMoreTypeformContent on Content {\n  __isContent: __typename\n  entityId\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment hooksSeriesArticleSectionTagArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase_3o8td4 on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3o8td4\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n  ... on Article {\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment infographicArticleArticle on Article {\n  ...globalCheckerContent\n  ...landingBannerInfographicArticle\n}\n\nfragment inlineArticleSeriesInlineArticle on Article {\n  entityId\n  seriesContainer {\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    series {\n      __typename\n      ... on Content {\n        __isContent: __typename\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...entityLink\n    id\n  }\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment issuesDropdownNewsletterArticleArticle on Article {\n  entityId\n}\n\nfragment issuesNewsletterArticleArticle on Article {\n  types {\n    value {\n      entityUuid\n      id\n    }\n  }\n  ...issuesDropdownNewsletterArticleArticle\n}\n\nfragment itemLiveArticleContentArticle on Article {\n  entityId\n  sponsorType\n  urlAlias\n  ...articleImageGalleryContent\n  ...contentSchemaRenderContent\n  ...contentShareWidgetContent\n}\n\nfragment landingBannerInfographicArticle on Article {\n  ...articleSponsorContent\n  ...articleShareWidgetArticle\n  headline\n  topics {\n    ...entityLink\n    name\n    id\n  }\n  images {\n    title\n    url\n  }\n  coverHero: image(filter: {type: HERO}) {\n    url\n  }\n}\n\nfragment liveArticleArticle on Article {\n  entityId\n  entityUuid\n  ...articleImageGalleryContent\n  ...helpersCheckHasLiveTagArticle\n  ...contentLiveArticleArticle\n  ...globalCheckerContent\n  ...newsletterWidgetLiveArticleArticle\n  ...shareArticle20Content\n  ...articleBaseAdvertisingInfoArticle\n}\n\nfragment magazinesStyleArticleMoreOnThisContentItemContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...helpersCheckIsMainTopicContent\n  ...hooksContentItemProvidersContent_3JkJ9S\n}\n\nfragment morningStudioArticleContent on Content {\n  __isContent: __typename\n  ...globalCheckerContent\n  ...headerMorningStudioArticle\n}\n\nfragment newsletterArticleArticle on Article {\n  ...contentNewsletterArticleArticle\n  ...headerNewsletterArticleArticle\n  ...issuesNewsletterArticleArticle\n  ...widgetNewsletterArticleArticle\n}\n\nfragment newsletterWidgetLiveArticleArticle on Article {\n  ...contentNewsletterWidgetContent\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment paywallsGetArticlePaywallTagArticle on Article {\n  flag\n  topics {\n    entityId\n    id\n  }\n  ...helpersGetArticleTypeArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersIsSignInWallArticle\n  ...helpersIsArchiveWallArticle\n  ...helpersIsPlusInlinePaywall\n  ...helpersIsLiteWallArticle\n  ...helpersIsVelocityWallArticle\n}\n\nfragment pdfFileLinkPlusGenericArticleContent on Article {\n  entityId\n  ...helpersSendPdfFileTrackingArticle\n  ...helpersGetPdfFileUrlArticle\n  ...helpersGetArticleTypeArticle\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment pianoIntegrationArticle on Article {\n  __typename\n  contentLock\n  createdDate\n  entityId\n  entityUuid\n  headline\n  publishedDate\n  sponsor\n  sponsorType\n  urlAlias\n  flag\n  authors {\n    name\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        entityUuid\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    entityId\n    name\n    id\n  }\n  types {\n    value {\n      entityId\n      name\n      id\n    }\n  }\n  ...helpersAppBarVariantBase\n  ...hooksPaywallPromiseContent\n  ...helpersIsArchiveWallArticle\n  ...helpersIsVelocityWallArticle\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckCanShowInPlusPlatformContent\n  ...shareContentUnlockedArticle\n  ...paywallsGetArticlePaywallTagArticle\n}\n\nfragment plusArticleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    entityId\n    ...authorAvatarAuthor\n    id\n  }\n}\n\nfragment plusArticleTitleArticle on Article {\n  ...hooksContentHelperContent\n  ...articleTitleArticle\n  ...plusArticleTypeTitleContent\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusArticleTypeTitleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n}\n\nfragment plusAuthorCardAuthor on Author {\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  areaOfExpertise\n}\n\nfragment plusColumnsArticleContent on Content {\n  __isContent: __typename\n  ...articleTitleArticle\n  ...blockquoteQuotePlusGenericArticleContent\n  ...hooksContentHelperContent\n}\n\nfragment plusGenericArticleContent on Article {\n  entityId\n  sponsorType\n  ...articleAuthorDetailsContent\n  ...articleTopicsContent\n  ...articlePianoPaywallContent\n  ...helpersGetArticleTypeArticle\n  ...helpersGetPdfFileUrlArticle\n  ...helpersSendPdfFileTrackingArticle\n  ...blockquoteQuotePlusGenericArticleContent\n  ...pdfFileLinkPlusGenericArticleContent\n  ...plusArticleTitleArticle\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment postMagazineArticleContent on Content {\n  __isContent: __typename\n  ...helpersGetArticleTypeArticle\n  ...genericArticleContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment seriesArticleArticle on Article {\n  entityId\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  seriesReverseOrder\n  series {\n    __typename\n    ... on Content {\n      __isContent: __typename\n      ...seriesPrimaryContent\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...seriesBannerContent\n  ...shareArticle20Content\n}\n\nfragment seriesBannerContent on Content {\n  __isContent: __typename\n  ...hooksSeriesArticleSectionTagArticle\n  ...entityLink\n  ...hooksContentItemProvidersContent_2niEwz\n  publishedDate\n}\n\nfragment seriesPrimaryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3wWJWe\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareContentUnlockedArticle on Article {\n  entityId\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment styleArticleAuthorBlockArticle on Article {\n  createdDate\n  publishedDate\n  sponsorType\n  firstTopic {\n    sponsor {\n      name\n      type\n      id\n    }\n    id\n  }\n  authors {\n    ...authorNameAuthor\n    entityId\n    id\n  }\n  ...hooksContentHelperContent\n}\n\nfragment styleArticleContent on Content {\n  __isContent: __typename\n  entityId\n  ...articleImageGalleryContent\n  ...articleMoreOnThisListStyleArticle\n  ...globalCheckerContent\n  ...styleArticleAuthorBlockArticle\n}\n\nfragment styleAuthorCardAuthor on Author {\n  ...authorSocialLinksAuthor\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  ...entityFollowButtonBase\n}\n\nfragment subheaderMorningStudioSubheaderContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n  ...articleSponsorContent\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoArticleContent on Video {\n  duration\n  entityId\n  headline\n  socialHeadline\n  orientation\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  image(filter: {type: MAIN_IMAGE}) {\n    landscape: style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n    portrait: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n  ...articleBaseAdvertisingInfoArticle\n  ...helpersGetVideoYoutubeIdVideo\n  ...shareArticle20Content\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment widgetNewsletterArticleArticle on Article {\n  relatedNewsletters {\n    ...helpersMassageToNewsletterItemNewsletter\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "63263e088e6b991a106f53435a7225f8";

export default node;
